import React, { useState } from 'react'

import { Input, INPUT_THEME, Pagination, usePagination } from '@st-operations/uikit/src/v2'
import format from '@st-operations/uikit/lib/format.js'

import Table from '_components/table'
import ItemInfoCell from '_components/item-info-cell'

import './styles.scss'

const ProcessTab = ({ audiences = [] }) => {
  const [search, setSearch] = useState('')
  const { page, toPage } = usePagination(
    audiences.filter(({ name }) => !search || name.toLowerCase().includes(search.toLowerCase())),
    20
  )

  const handleSearch = (value) => setSearch(value)

  return (
    <>
      <div className="bpa-process__table-header">
        <Input
          theme={INPUT_THEME.SEARCH}
          placeholder="Search Audiences"
          value={search}
          onChange={handleSearch}
        />
        <Pagination
          options={{ length: page.quantity }}
          page={page.number - 1}
          onPageChange={(page) => toPage(page.label)}
        />
      </div>
      <Table
        columns={[
          {
            name: 'Name',
            key: 'name',
            width: 500,
            render: (item) => (
              <ItemInfoCell
                item={item}
                key={`item-${item.index}`}
                href={`/audience-creator/${item._id}`}
              />
            ),
          },
          {
            name: 'Prebuilt Attribute Size',
            render: (item) => format('metric', item.prebuiltAttributeSize),
          },
          {
            name: 'Audience Status',
            key: 'status',
          },
        ]}
        sort_key={null}
        data={page.content}
      />
    </>
  )
}

export default ProcessTab
